import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Privacy from '../views/Privacy.vue'
import Support from '../views/Support.vue'
import Contact from '../views/Contact.vue'
import i18n from '../i18n'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/support',
    name: 'Support',
    component: Support
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 支持通过 ?lang=en / ?lang=zh 切换语言
router.beforeEach((to, from, next) => {
  const lang = to.query.lang
  if (lang === 'en' || lang === 'zh') {
    try {
      // legacy 模式下直接设置 locale
      i18n.global.locale = lang
      localStorage.setItem('locale', lang)
    } catch (e) {
      // 忽略异常，继续导航
    }
  }
  next()
})

export default router

